import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/Testingcommissioning.css';
import backgroundImage from '../assets/Testing-bg.jpg';
import smallImage from '../assets/testing.jpg';

const scrollText = [
  "TRANSFORMER TESTING", "HV & MV PANEL TESTING", "SWITCHGEAR TESTING",
  "BATTERY SYSTEM TESTING", "POWER QUALITY TESTING", "EARTH SYSTEM TESTING","HIGH VOLTAGE TEST","OVER HEADLINE TEST","MOTOR TEST","ANNUAL MAINTANANCE","CAPACITOR BANK TEST","RELAY TEST","CT/VT TEST"
];

const Testingcommissioning = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />

      {/* Top Section */}
      <div
        className="testingcommissioning-container"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        <div className="testingcommissioning-content">
          <div className="text-section fade-in-up">
            <h1>Testing & Commissioning</h1>
            <p>
              Apexcel offers testing and commissioning services to substations. We provide
              electrical testing in industrial sectors like Petrochemicals, Refinery, Oil & Gas,
              Power Transmission and Distribution, Telecommunication, Steel, Pharmaceuticals, and
              commercial sectors like Hotels, Hospitals, Malls, and High-rise buildings.
            </p>
          </div>
          <div className="image-section fade-in-up">
            <img src={smallImage} alt="Testing and Commissioning" />
          </div>
        </div>
      </div>

      {/* Feature Boxes */}
      <div className="feature-boxes-wrapper">
        <div className="box-grid">
          {[
            {
              title: 'SERVICE SUITABILITY',
              description:
                'Our standard procedures effectively establish the ability of a service to fulfill needs while saving time and cost.',
            },
            {
              title: 'FINE DELIVERABLES',
              description:
                'We ensure outcomes reflect efficiency and finesse in the assigned works.',
            },
            {
              title: 'PROFESSIONAL TEAM',
              description:
                'We train our T&C Engineers periodically to provide professional services and minimize risks.',
            },
            {
              title: 'ON DEMAND TESTING',
              description:
                'We deploy experienced engineers with certified equipment to sites quickly.',
            },
            {
              title: 'HIGH ON COMPLIANCES',
              description:
                'We perform testing under IEEE, IEC, and ANSI standards for assurance and reliability.',
            },
            {
              title: 'REPORTS ARCHIVE',
              description:
                'We maintain an online archive of all testing reports carried out by our team.',
            },
          ].map((box, idx) => (
            <div
              key={idx}
              className="feature-box fade-in-up"
              style={{ animationDelay: `${idx * 0.2}s` }}
            >
              <h3>{box.title}</h3>
              <p>{box.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Infinite Scrolling Text */}
      <section className="tc-scroller-section">
        <article className="tc-scroller-carousel">
          <div className="tc-scroller-track">
            <div className="tc-scroller-list">
              {[...scrollText, ...scrollText].map((text, index) => (
                <div key={index} className="tc-scroller-item">
                  {text}
                </div>
              ))}
            </div>
          </div>
        </article>
      </section>

      <Footer />
    </>
  );
};

export default Testingcommissioning;
